export default __webpack_public_path__ + "static/bucky_stretching-c89edcb75ff072f36efe72f3552d234f.jpeg";